import { TimesheetHourBreakExtended } from '../../../interfaces/timesheet.interface';

export class SetTimesheetHourBreaks {
    public static readonly type = '[JobsPlacements] Set timesheet hour breaks';

    constructor(public timesheetHourBreaks: Array<TimesheetHourBreakExtended>) { }
}
